import Link from "next/link";
import Typography from "./Typography";

// The consent line under every sign-in / sign-up form (`/login`, `/signup`
// and the signup dialog).
export default function AuthLegalNotice({ className }: { className?: string }) {
  return (
    <Typography
      variant="caption"
      className={`text-center text-slate-500 ${className ?? ""}`}
    >
      By continuing, I agree to the{" "}
      <Link target="_blank" href="/terms-of-services">
        Terms of service
      </Link>{" "}
      and{" "}
      <Link target="_blank" href="/privacy-policy">
        Privacy policy
      </Link>
    </Typography>
  );
}
